import { render, staticRenderFns } from "./HomeworkAnswer.vue?vue&type=template&id=57b05b50&"
import script from "./HomeworkAnswer.vue?vue&type=script&lang=js&"
export * from "./HomeworkAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports